// React import
import * as React from 'react';
// Standard layout imports
import { Columns, Column } from 'src/components/Layout/Grid';
import Wrapper from 'src/components/Wrapper';
import notePic from 'src/images/Courses/note.png';
import Box from 'src/components/Box';
import Title from 'src/components/Title';
import Tag from 'src/components/Tag';
import Label from 'src/components/FormElements/Label';
import Button from 'src/components/Button';
import Icon from 'src/components/Icon';
import Line from 'src/components/Line';
import {
  IActivityModel,
  ISubActivityModel
} from 'src/Entities/Activity/Activity';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import { IActivityCategoryModel } from 'src/Entities/ActivityCategory/ActivityCategory';
import { IActivityThemeModel } from 'src/Entities/ActivityTheme/ActivityTheme';
import { webGetActivityDetailsAction } from 'src/Entities/Activity/Activity.Actions';
import Breadcrumb from 'src/components/Breadcrumb';
import BreadcrumbItem from 'src/components/Breadcrumb/BreadcrumbItem';
import { Link } from 'react-router-dom';
import SubActivitiesComponent from './subActivities.component';
import SubActivitiesComponentIsAdvertisement from './subActivities.componentIsAdvertisement';
import SubActivitiesComponentOtherInfo from './subActivities.componentOtherInfo';
import {
  webSetUserFavoriteAction,
  webRemoveUserFavoriteAction
} from 'src/Entities/User/User.Actions';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { tilmeldmigUrl } from 'src/helpers/WebHelper';
import {
  format,
  isAfter,
  addDays,
  getDate,
  getTime,
  parse,
  toDate
} from 'date-fns';
import SameTitleActivities from './sameTitelCourses.component';
import Tooltip from 'src/components/Tooltip';
import { PortalStateSelector } from 'src/Entities/PortalState/PortalState.Selector';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';
import { IComingCourses } from 'src/Entities/User/User';
import 'url-search-params-polyfill';
import activityStatus from 'src/utils/activityStatusUtils';
import { time } from 'console';

// import { ActivitySelector } from 'src/Entities/Activity/Activity.Selector';

export interface IActivityProps {
  selectedActivity: IActivityModel;
  selectedCategory: IActivityCategoryModel;
  selectedTheme: IActivityThemeModel;
  sameTitleActivities: IActivityModel[];
  comingCourses: IComingCourses[];
  getActivityDetails: (detailkursusId: string) => void;
  addToFavorite: (detailkursusId: number) => void;
  removeFromFavorite: (detailkursusId: number) => void;
  setSelectedActivity: (
    detailKursuId: string,
    themeId: string,
    categoryId: string
  ) => void;
}
interface IState {
  isFavorite: boolean;
}
class ActivityPage extends React.Component<IActivityProps, IState> {
  /**
   *
   */
  constructor(props: any) {
    super(props);
    this.state = {
      isFavorite: this.props.selectedActivity
        ? UserSelector.isUserFavorites(
            this.props.selectedActivity.detailKursusId
          )
        : false
    };

    if (!this.props.selectedActivity) {
      const urlParams = new URLSearchParams(props.location.search);
      const Ids = urlParams.get('id');
      if (Ids !== null) {
        const splittedIds = Ids.split('-');
        this.props.getActivityDetails(splittedIds[2]);
        this.props.setSelectedActivity(
          splittedIds[2],
          splittedIds[0],
          splittedIds[1]
        );
      }
    } else {
      this.props.getActivityDetails(
        this.props.selectedActivity.detailKursusId.toString()
      );
      if (window.location.href.indexOf('?id') === -1) {
        window.location.replace(
          window.location.href +
            `?id=${this.props.selectedTheme.themeId}-${this.props.selectedCategory.categoryId}-${this.props.selectedActivity.detailKursusId}`
        );
      }
    }

    // always bind eventhandlers to 'this'
    this.activitySelected = this.activitySelected.bind(this);
    this.onEnrollClick = this.onEnrollClick.bind(this);
    this.OnFavoriteClick = this.OnFavoriteClick.bind(this);
  }
  public onEnrollClick() {
    window.open(tilmeldmigUrl + this.props.selectedActivity.fiuNo, '_blank');
  }

  public activitySelected(detailKursusId: number) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.props.setSelectedActivity(
      detailKursusId.toString(),
      this.props.selectedTheme.themeId.toString(),
      this.props.selectedCategory.categoryId.toString()
    );
    this.props.getActivityDetails(detailKursusId.toString());
  }
  public OnFavoriteClick() {
    const detailId = this.props.selectedActivity.detailKursusId;
    if (!this.state.isFavorite) {
      this.props.addToFavorite(detailId);
    } else {
      this.props.removeFromFavorite(detailId);
    }
    this.setState(
      Object.assign(this.state, { isFavorite: !this.state.isFavorite })
    );
  }

  public formatFiuNo(fiuNo: string) {
    const seperator = '-';
    const formattedNo = [
      fiuNo.slice(0, 4),
      seperator,
      fiuNo.slice(4, 6),
      seperator,
      fiuNo.slice(6, 8),
      seperator,
      fiuNo.slice(8, 10)
    ].join('');
    return formattedNo;
  }
  public OnBackClick() {
    window.history.back();
  }

  public courseLink() {
    return `https://${location.host}/kursusportal/%23/kursus/?id=${this.props.selectedTheme.themeId}-${this.props.selectedCategory.categoryId}-${this.props.selectedActivity.detailKursusId}`;
  }

  public mailLink() {
    return (
      'mailto:?subject=' +
      this.props.selectedActivity.courseTitle +
      "&body=Du skal være logget på kursusportalen fra 3FI's forside, for at du kan bruge linket: " +
      this.courseLink()
    );
  }

  public renderActivity() {
    const { selectedActivity } = this.props;
    const startDate: string = format(
      new Date(selectedActivity.startDate),
      'dd.MM.yyyy'
    );
    const endDate: string = format(
      new Date(selectedActivity.endDate),
      'dd.MM.yyyy'
    );
    const date =
      startDate === endDate ? startDate : `${startDate} - ${endDate}`;
    const actStatus = activityStatus(this.props.selectedActivity);
    const hasEnrollmentDatePassed =
      actStatus === 'lastEnrollmentDatePassed' ? true : false;

    const subActivitiesWithLocation: ISubActivityModel[] = selectedActivity.subActivities
      ? selectedActivity.subActivities.filter(
          subActivity => subActivity.location
        )
      : [];

    const isCourseCancelled =
      this.props.selectedActivity.admStatus === 'K' ? true : false;

    const element = (
      <div>
        <Wrapper>
          <Breadcrumb className="pt3">
            <BreadcrumbItem>
              <Link to="/Home">FORSIDE</Link>{' '}
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to="/kurser/">KURSER</Link>{' '}
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to={'/Kurser/' + this.props.selectedTheme.themeId}>
                {this.props.selectedTheme.name}
              </Link>{' '}
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to={'/Kurser/' + this.props.selectedTheme.themeId}>
                {this.props.selectedCategory.name}
              </Link>{' '}
            </BreadcrumbItem>
            <BreadcrumbItem active={true}>
              <Link to="">{this.props.selectedActivity.courseTitle}</Link>
            </BreadcrumbItem>
          </Breadcrumb>
        </Wrapper>

        <Wrapper>
          <div className="className=columns has-default-gutter mb-8 mt2">
            <Columns className="has-background-gray-body h200">
              <Column
                lg={6}
                className="order-1 order-0-lg p-4 flex flex-column"
              >
                <div className="flex-1 pa1">
                  <Tag color="gray" className="mr-2">{this.props.selectedTheme.name}</Tag>
                  {this.props.selectedActivity.tag
                    ? <Tag {...this.props.selectedActivity.tag} />
                    : null}
                  <div>
                    <p className="m-0 mt-1 uppercase f1">
                      {selectedActivity.courseTitle}
                    </p>
                  </div>
                  <div className="mb2 mt2">
                    {this.props.selectedActivity.isAdvertisement !== true && this.props.selectedActivity.startDate &&
                    this.props.selectedActivity.endDate ? (
                      <div>
                        {' '}
                        <b>Dato: </b>{' '}
                        {format(
                          new Date(selectedActivity.startDate),
                          'dd.MM.yyyy'
                        )}{' '}
                        {selectedActivity.startTime} -{' '}
                        {format(
                          new Date(selectedActivity.endDate),
                          'dd.MM.yyyy'
                        )}{' '}
                        {selectedActivity.endTime}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div
                    className="ma2"
                    style={{ margin: 'auto ', display: 'inline-flex' }}
                  >
                    <Tooltip />
                    <div
                      className="mr1"
                      data-tip={
                        this.state.isFavorite
                          ? 'Fjern fra din favoritliste'
                          : 'tilføj til din favoritliste'
                      }
                    >
                      <Button
                        color="light"
                        size="small"
                        onClick={this.OnFavoriteClick}
                      >
                        <Icon
                          name="star"
                          color={this.state.isFavorite ? '#FAC917' : 'gray'}
                        />
                      </Button>
                    </div>
                    <Tooltip />
                    <a
                      href={this.mailLink()}
                      data-tip="Tip en ven"
                      target="_top"
                    >
                      <Button className="mr1" color="light" size="small">
                        <Icon name="envelope" />
                      </Button>
                    </a>
                  </div>
                </div>
                <div className="Boxbar">
                  <Box className="box-small">
                    <Columns className="justify-between">
                      <Column md={4}>
                        <Label>
                          <strong>Ledige Pladser</strong>
                        </Label>
                        {this.props.selectedActivity.spotsLeft > 0
                          ? 'Ja'
                          : 'Nej'}
                        {this.props.selectedActivity.FewSpotsLeft ? (
                          <span className="b ml-1 f5">Få pladser tilbage</span>
                        ) : (
                          ''
                        )}
                      </Column>

                      {this.props.selectedActivity.isAdvertisement ===
                        false && (
                        <Column md={5}>
                          <Label>
                            <strong>ANSØGNINGSFRIST</strong>
                          </Label>

                          {format(
                            new Date(
                              this.props.selectedActivity.lastEnrollmentDate
                            ),
                            'dd.MM.yyyy'
                          )}

                          {actStatus === 'lastEnrollmentDatePassed' ? (
                            <Tag
                              className="ml2"
                              color="cancelled"
                              tooltip="Hvis du er interesseret i et lignende kursus, anbefales du at kontakte udbyder"
                            >
                              TILMELDINGSFRIST UDLØBET
                            </Tag>
                          ) : null}
                          {actStatus === 'lastChance' ? (
                            <Tag
                              className="ml2"
                              color="warning"
                              tooltip="Der er x-antal dage til tilmeldingsfristen udløber"
                            >
                              SIDSTE CHANCE
                            </Tag>
                          ) : null}
                        </Column>
                      )}

                      {this.props.selectedActivity.signUpForm !== 'A' ? (
                        !isCourseCancelled && !hasEnrollmentDatePassed ? (
                          <Column md={3} className="tr mt1">
                            <div
                              style={{
                                margin: 'auto 0',
                                display: 'inline-flex'
                              }}
                            >
                              {!this.props.comingCourses.find(
                                cc =>
                                  cc.detailKursusId ===
                                  this.props.selectedActivity.detailKursusId
                              ) ? (
                                <div>
                                  {this.props.selectedActivity
                                    .courseSpecialNote ? (
                                    <div>
                                      <Tooltip />
                                      <div data-tip="Har du læst bemærkningen">
                                        <Button
                                          color="primary"
                                          onClick={this.onEnrollClick}
                                        >
                                          Ansøg <Icon name="chevron-right" />
                                        </Button>
                                      </div>
                                    </div>
                                  ) : (
                                    <Button
                                      color="primary"
                                      onClick={this.onEnrollClick}
                                    >
                                      Ansøg <Icon name="chevron-right" />
                                    </Button>
                                  )}
                                </div>
                              ) : (
                                <div>
                                  <Tooltip />
                                  <div data-tip="Du er registreret på dette kursus">
                                    <Button color="primary" disabled={true}>
                                      Ansøg <Icon name="chevron-right" />
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </Column>
                        ) : (
                          <Column md={3} className="tr mt1" />
                        )
                      ) : (
                        ''
                      )}
                    </Columns>
                  </Box>
                </div>
              </Column>
              <Column className="order-1 order-0-lg p-4 flex flex-column is-lg-6">
                <img
                  src={notePic}
                  width="full"
                  height="300"
                  alt="writtenNote"
                />
              </Column>
            </Columns>
          </div>
        </Wrapper>

        <div className="pa3 has-background-gray-body">
          <Wrapper>
            <Columns gutter="default">
              <Column md={8}>
                {this.props.selectedActivity.courseSpecialNote ? (
                  <div>
                    <Title className="mb2">Bemærk</Title>
                    <Box className="mb4">
                      {this.props.selectedActivity.courseSpecialNote}
                    </Box>
                  </div>
                ) : null}
                <Title className="mb2">Beskrivelse af kurset</Title>
                <Box className="mb4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.selectedActivity.description
                    }}
                  />
                </Box>
                <Line className="my4" />
                {this.props.sameTitleActivities.length > 0 ? (
                  <SameTitleActivities
                    setSelectedActivity={this.activitySelected}
                    activities={this.props.sameTitleActivities}
                  />
                ) : null}
              </Column>
              <Column md={4}>
                {selectedActivity.isAdvertisement &&
                  subActivitiesWithLocation.length > 0 && (
                    <div>
                      <Title className="mb2">DELAKTIVITETER</Title>
                      <SubActivitiesComponentIsAdvertisement
                        subActivities={subActivitiesWithLocation}
                      />
                    </div>
                  )}
                {!selectedActivity.isAdvertisement &&
                  selectedActivity.subActivities && (
                    <div>
                      <Title className="mb2">DELAKTIVITETER</Title>
                      <SubActivitiesComponent
                        subActivities={selectedActivity.subActivities}
                      />
                    </div>
                  )}
                <Title className="mt2 mb2">ANDEN KURSUSINFO</Title>
                <SubActivitiesComponentOtherInfo
                  activityModel={selectedActivity}
                />
              </Column>
            </Columns>
          </Wrapper>
        </div>
      </div>
    );
    return element;
  }

  public render() {
    return (
      <div>{this.props.selectedActivity ? this.renderActivity() : null}</div>
    );
  }
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    selectedActivity: PortalStateSelector.getSelectedActivity(),
    selectedCategory: PortalStateSelector.getSelectedCategory(),
    selectedTheme: PortalStateSelector.getSelectedTheme(),
    sameTitleActivities: PortalStateSelector.getActivitiesWithSameTitle(),
    comingCourses: UserSelector.getUserComingCourses()
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  // add to favorites
  return {
    getActivityDetails: (detailkursusId: string) => {
      dispatch(webGetActivityDetailsAction(detailkursusId));
    },
    addToFavorite: (detailkursusId: number) =>
      dispatch(webSetUserFavoriteAction(detailkursusId)),
    removeFromFavorite: (detailkursusId: number) =>
      dispatch(webRemoveUserFavoriteAction(detailkursusId)),
    setSelectedActivity: (
      detailKursusid: string,
      themeId: string,
      categoryId: string
    ) => dispatch(setSlecetedActivtyAction(detailKursusid, themeId, categoryId))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ActivityPage);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/index.tsx